import { render } from "./WorkerMonitoring.vue?vue&type=template&id=66167470&scoped=true"
import script from "./WorkerMonitoring.vue?vue&type=script&lang=js"
export * from "./WorkerMonitoring.vue?vue&type=script&lang=js"

import "./WorkerMonitoring.vue?vue&type=style&index=0&id=66167470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66167470"]])

export default __exports__